module.exports = __webpack_public_path__ + "e21466a343c80653f2afdefe2fddb121.svg";